export const adaptCDResumen = (data) => {
    const { cuidadosDomiciliariosRI } = data;

    return {
        ...cuidadosDomiciliariosRI,
        videodeglucionAdjuntoCD: !!data?.videodeglucionAdjunto?.contentType ? {
            contentType: data?.videodeglucionAdjunto?.contentType,
            archivo: data?.videodeglucionAdjunto?.archivo,
            extension: data?.videodeglucionAdjunto?.extension,
            titulo: data?.videodeglucionAdjunto?.titulo,
        } : null,
        sNCCD: cuidadosDomiciliariosRI?.sNC,
        cVCD: cuidadosDomiciliariosRI?.cV,
        respiratorioCD: cuidadosDomiciliariosRI?.respiratorio,
        digestivoCD: cuidadosDomiciliariosRI?.digestivo,
        videodeglucionCD: cuidadosDomiciliariosRI?.videodeglucion,
        otrosCD: cuidadosDomiciliariosRI?.otros,
        traqueostomiaCD: cuidadosDomiciliariosRI?.traqueostomia,
        sondaVesicalCD: cuidadosDomiciliariosRI?.sondaVesical,
        ostomiaCD: cuidadosDomiciliariosRI?.ostomia,
        cateterCD: cuidadosDomiciliariosRI?.cateter,
        sondaNasogastricaCD: cuidadosDomiciliariosRI?.sondaNasogastrica,
        idComboRIValorCalendarioVacunasCD: cuidadosDomiciliariosRI?.idComboRIValorCalendarioVacunasNavigation?.valor,
        idComboRIValorAduKarnofskyCD: cuidadosDomiciliariosRI?.idComboRIValorAduKarnofskyNavigation?.valor,
        idComboRIValorPedLANSKYCD: cuidadosDomiciliariosRI?.idComboRIValorPedLANSKYNavigation?.valor,
        requiereSoporteNutricionalCD: cuidadosDomiciliariosRI?.requiereSoporteNutricional,
        idComboRIValorTabaquismoCD: cuidadosDomiciliariosRI?.idComboRIValorTabaquismoNavigation?.valor,
        antecedenteConsumoSustanciaCD: cuidadosDomiciliariosRI?.antecedenteConsumoSustancia,
    }
}
